var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0H6.875C3.07804 0 0 3.07804 0 6.875V37.125C0 40.922 3.07804 44 6.875 44H37.125C40.922 44 44 40.922 44 37.125V6.875C44 3.07804 40.922 0 37.125 0Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80555 15.2078L22 21.805L35.1945 15.2078C35.095 13.4747 33.6581 12.1 31.9 12.1H12.1C10.342 12.1 8.90505 13.4747 8.80555 15.2078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 18.8945L22 25.4946L8.80005 18.8946V28.6C8.80005 30.4225 10.2775 31.9 12.1 31.9H31.9C33.7226 31.9 35.2 30.4225 35.2 28.6V18.8945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.39f19c8a2ae80b0059180d9ade5cc355.svg";
export { ForwardRef as ReactComponent };